import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'

export const Cell = styled(Skeleton)`
    height: 30px;
    width: 100%;
`

export const ActionButton = styled(Skeleton)`
    height: 24px !important;
    width: 24px !important;
    border-radius: 50% !important;
`

export const Table = styled.table`
    width: 100%;
`

export const TD = styled.td`
    padding: 0px 2px;
    &.actions {
        width: 100px !important;
    }
`

export const ActionButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: '100%';
`

export const ActionWrapper = styled.div`
    width: 26px;
    height: 26px;
    border-radius: 100%;
    overflow: hidden;
`
